import { useEffect, useRef, useState } from 'react';
import environmentConfig from '../../../../config/environment-configs';
import Box from '../../../../components/Section/Box';
import Arrow from './Arrow';
import { useAuth } from '../../../../hooks/useAuth';
import { Container, Button } from './styles';
import { Actions, Categories, Labels } from '../../../../types/gtm';

const BoxOffers = () => {
  const carouselRef = useRef<any>(null);
  const [carouselPosition, setCarouselPosition] = useState('left');
  const [, setWithPropension] = useState(false);
  const originId = environmentConfig.ORIGIN_ID;
  const urlParams = JSON.stringify([
    { name: 'default', params: { origemId: originId } },
  ]);

  const calculateDestination = (
    currentIndex: number,
    direction: string,
  ): number => {
    const directionValue = direction === '>' ? 1 : -1;
    return currentIndex + 1 + directionValue;
  };

  const updateCarouselPosition = (currentIndex: number, length: number) => {
    switch (currentIndex) {
      case 0:
        setCarouselPosition('left');
        break;
      case length - 1:
        setCarouselPosition('right');
        break;
      default:
        setCarouselPosition('middle');
    }
  };

  const sendEvent = (
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
    event: string,
  ) => {
    window.dataLayer.push({ eventCategory, eventAction, eventLabel, event });
  };

  const logWidgetViewEvent = () => {
    sendEvent(
      Categories.Home,
      Actions.WidgetView,
      Labels.SalesCarouselScreen,
      'customEventUserInteraction',
    );
  };

  const logCardMovementEvent = (
    direction: string,
    from: number,
    to: number,
  ) => {
    sendEvent(
      Categories.Home,
      direction,
      `Vitrine - Posicao ${from + 1} para ${to}`,
      'customEventUserInteraction',
    );
  };

  const logCardClickEvent = (hero: any, index: number) => {
    sendEvent(
      Categories.Home,
      `Clique ${hero.title}`,
      `Vitrine - Posicao do Produto ${index + 1}`,
      'customEventUserInteraction',
    );
  };

  const logCardDraggedEvent = () => {
    sendEvent(
      Categories.Home,
      Actions.DragCard,
      `Vitrine`,
      'customEventUserInteraction',
    );
  };

  const logHeroesLoadedEvent = (quantity: number) => {
    sendEvent(
      Categories.Home,
      Actions.AmountOfCards,
      `Vitrine - ${quantity} Cards`,
      'customEventUserInteraction',
    );
  };

  const move = (direction: string, from: number, to: string) => {
    const carousel: any = carouselRef.current;
    carousel.go(to);
    updateCarouselPosition(carousel.index, carousel.length);
    logCardMovementEvent(direction, from, calculateDestination(from, to));
  };

  const moveLeft = () => {
    const from = carouselRef.current.index;
    const to = '<';
    const direction = Actions.ClickLeftArrow;
    move(direction, from, to);
  };

  const moveRight = () => {
    const from = carouselRef.current.index;
    const to = '>';
    const direction = Actions.ClickRightArrow;
    move(direction, from, to);
  };

  const handleGetCarouselComponent = (event: any) => {
    carouselRef.current = event.detail;
    logWidgetViewEvent();
  };

  const handleHeroesLoaded = (event: any) => {
    const hasPropension = event.detail.withPropension;
    setWithPropension(hasPropension);
    logHeroesLoadedEvent(event.detail.quantity);
  };

  const handleCardClicked = (event: any) => {
    const { hero, index } = event.detail;
    logCardClickEvent(hero, index);
  };

  const handleGetCarouselDragged = () => {
    logCardDraggedEvent();
  };

  useEffect(() => {
    const vtr = (document as any).querySelector('vtr-hero-nbo');
    vtr.addEventListener('getCarouselComponent', handleGetCarouselComponent);
    vtr.addEventListener('onHeroesLoaded', handleHeroesLoaded);
    vtr.addEventListener('onCardClicked', handleCardClicked);
    vtr.addEventListener('onCarouselDragged', handleGetCarouselDragged);

    return () => {
      vtr.removeEventListener(
        'getCarouselComponent',
        handleGetCarouselComponent,
      );
      vtr.removeEventListener('onHeroesLoaded', handleHeroesLoaded);
      vtr.removeEventListener('onCardClicked', handleCardClicked);
      vtr.removeEventListener('onCarouselDragged', handleGetCarouselDragged);
    };
  }, []);

  const { user } = useAuth();
  const title = 'Conheça nossos produtos';
  const describeTitle =
    'Aproveite os melhores combos Globo e parceiros, com seus produtos favoritos';
  let reactAppEnv = 'DEV';
  if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV !== 'local') {
    reactAppEnv = process.env.REACT_APP_ENV;
  }
  const env: string = reactAppEnv.toUpperCase();
  return (
    <Box title={title} describeTitle={describeTitle}>
      <Container>
        <div className="carousel-header">
          <div>
            <h3>Ofertas para você</h3>
          </div>
          <div>
            <Button onClick={moveLeft} disabled={carouselPosition === 'left'}>
              <Arrow />
            </Button>
            <Button onClick={moveRight} disabled={carouselPosition === 'right'}>
              <Arrow />
            </Button>
          </div>
        </div>
        <hr aria-hidden="true" />
        <vtr-hero-nbo
          carousel-title=""
          card-quantity="3"
          globo-id={user.globoId}
          url-params={urlParams}
          env={env}
        />
        <div className="carousel-footer">
          <Button onClick={moveLeft} disabled={carouselPosition === 'left'}>
            <Arrow />
          </Button>
          <Button onClick={moveRight} disabled={carouselPosition === 'right'}>
            <Arrow />
          </Button>
        </div>
      </Container>
    </Box>
  );
};

export default BoxOffers;
